import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const UpdateFlowConfigConfigSchema = z
  .object({
    practiceId: z.string().optional(),
    entityType: z.string().optional(),
    entityId: z.string().optional(),
  })
  .refine((obj) => !obj.entityType === !obj.entityId, {
    message: 'entityType and entityId must be specified together (or must both be unspecified)',
    path: ['entityId'],
  })
  .refine((obj) => obj.practiceId ?? obj.entityId, {
    message: 'At least one of practiceId and/or entityType + entityId must be specified',
    path: ['practiceId'],
  });

export const UpdateFlowConfigSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.UpdateFlowConfig),
  returnType: returnTypeSchema(ProducedType.UpdateFlowConfigData),
  config: UpdateFlowConfigConfigSchema,
});

export type UpdateFlowConfigBlock = z.infer<typeof UpdateFlowConfigSchema>;
